@import '../../scss/mixins';

:host {
  display: block;
}

.spw-message {
  padding: 24px;
  border-radius: 16px;
  color: var(--spw-colors-support-grey-grey-900);
  font-size: 16px;

  &__title-container {
    display: flex;
    gap: 24px;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: column;
    @include breakpoint(lg) {
      flex-direction: row;
    }
  }

  &__close {
    order: -1;
    @include breakpoint(lg) {
      order: initial;
    }
  }

  &__title {
    font-size: 18px;
    flex: 1;
    display: block;
    spw-icon,
    .spw-icon {
      position: relative;
      margin-right: 6px;
      top: 1px;
    }
  }

  &__text {
    margin-top: 12px;
  }

  &--default {
    background: var(--spw-colors-support-grey-grey-100);
  }

  &--success {
    background: var(--spw-colors-multi-branding-green-green-50);
    spw-icon,
    .spw-icon {
      color: var(--spw-colors-multi-branding-green-green-600);
    }
  }

  &--alert {
    background: var(--spw-colors-multi-branding-red-red-50);
    spw-icon,
    .spw-icon {
      color: var(--spw-colors-multi-branding-red-red-accent-3);
    }
  }

  &--info {
    background: var(--spw-colors-multi-branding-blue-blue-50);
    spw-icon,
    .spw-icon {
      color: var(--spw-colors-multi-branding-blue-blue-accent-3);
    }
  }

  &--warning {
    background: #fffdeb;
    spw-icon,
    .spw-icon {
      color: #e6b800;
    }
  }

  spw-link {
    --spw-link-color: var(--spw-colors-support-grey-grey-900);
    --spw-link-hover-color: var(--spw-colors-support-grey-grey-900);
    --spw-link-active-color: var(--spw-colors-support-grey-grey-800);
    --spw-link-padding: 12px;
    &:focus-visible {
      outline-offset: 1px;
      outline: 2px solid var(--spw-ds-focus);
    }
  }
}
